var blockquote_default = {
  "fontElementMap": "c3kaM",
  "quote": "frpnT"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
